import {
  SET_SO_DISPLAY_ID, SET_SO_CUSTOMER_ID, SET_SO_PRODUCTS, SET_SO_DATE, SET_SO_STATUS, SET_SO_TOTAL, SET_SO_PAYMENTS, SET_SO_ACTIVE_STEP, SET_NEW_SO_INFO, CLEAR_NEW_SO
} from 'redux/actionTypes';

export const setNewSODisplayId = value => ({
  type: SET_SO_DISPLAY_ID,
  payload: value
});

export const setNewSOCustomerId = value => ({
  type: SET_SO_CUSTOMER_ID,
  payload: value
});

export const setNewSOProducts = value => ({
  type: SET_SO_PRODUCTS,
  payload: value
});

export const setNewSODate = value => ({
  type: SET_SO_DATE,
  payload: value
});

export const setNewSOStatus = value => ({
  type: SET_SO_STATUS,
  payload: value
});

export const setNewSOTotal = value => ({
  type: SET_SO_TOTAL,
  payload: value
});

export const setNewSOPayments = value => ({
  type: SET_SO_PAYMENTS,
  payload: value
});

export const setNewSOActiveStep = value => ({
  type: SET_SO_ACTIVE_STEP,
  payload: value
});

export const setNewSOInfo = data => ({
  type: SET_NEW_SO_INFO,
  payload: data
});

export const clearNewSO = () => ({
  type: CLEAR_NEW_SO
});